import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import persistState from 'redux-localstorage';
import get from 'lodash/get';
import gridNames from 'common/gridNames';
import rootReducer from './rootReducer';
import initialState from './initialState';
import signalRMiddleware from '../hub-connection/middleware';

const actionSanitizer = action =>
  action.type === 'STORE_BIG_STATIC_DICTIONARIES' && action.data
    ? { ...action, data: '<<LONG_BLOB>>' }
    : action;

const stateSanitizer = state =>
  get(state, 'dictionary.static.zipCodes')
    ? {
        ...state,
        dictionary: {
          ...state.dictionary,
          static: {
            ...state.dictionary.static,
            zipCodes: '<<LONG_BLOB>>',
            zipCodeCodes: '<<LONG_BLOB>>',
          },
        },
      }
    : state;

function getPathsForGridSettings() {
  return Object.keys(gridNames).map(x => `${x}_columnsInfo`);
}

function configureStore() {
  // const composeEnhancers = composeWithDevTools({ trace: true, traceLimit: 25 });
  const composeEnhancers = composeWithDevTools({
    actionSanitizer,
    stateSanitizer,
  });

  const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(
      applyMiddleware(thunk, signalRMiddleware),
      persistState(['auth', ...getPathsForGridSettings()]),
    ),
  );

  if (process.env.NODE_ENV !== 'production') {
    if (module.hot) {
      module.hot.accept('./rootReducer', () => {
        store.replaceReducer(rootReducer);
      });
    }
  }

  return store;
}

const store = configureStore();

export default store;
